// sources with more hosts than this have their hosts omitted from the leads filters, rendering them all makes the page unresponsive
export const LEAD_FILTER_SOURCE_HOSTS_LIMIT = 100;
